import React from 'react';
import { useQuery, gql } from "@apollo/client";
import { Image, Loader } from "semantic-ui-react";

const FAILSAFE_NAME = "Unknown Unicorn";

const COLORS = [
  ["#2185d0", "white"],
  ["#00b5ad", "white"],
  ["#21ba45", "white"],
  ["#767676", "white"],
  ["#6435c9", "white"],
  ["#b5cc18", "black"],
  ["#fbbd08", "black"],
  ["#f2711c", "black"],

]

const persistor = {};

export const GET_USER_INFO = gql`
  query getContactInfoForAvatar($userId: String!) {
    user: getContactInfo(userId: $userId) {
      id
      email
      name
      firstName
      lastName
      avatar
      hasAvatar
    }
  }
`;

function getInitials(name: string): string {
  const [firstName, lastName] = (name || FAILSAFE_NAME).split(' ');

  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  return firstName.charAt(0).toUpperCase();
}

const InitialsAvatarComponent: React.FC<InitialsAvatarProps> = ({ name, userId }) => {
  let colorScheme = persistor[userId];
  if (!colorScheme) {
    persistor[userId] = COLORS[Math.floor(Math.random() * COLORS.length)];
  }
  const [bgColor, fontColor] = persistor[userId];
  return (
    <>
      <div
        aria-label={name}
        role="img"
        className="initials-avatar"
        style={{ backgroundColor: bgColor }}
      >
        <div style={{ color: fontColor }}>{getInitials(name)}</div>
      </div>
    </>
  );
};

interface InitialsAvatarProps {
  user?: {
    name: string;
    avatar?: string;
    hasAvatar?: boolean;
  }
  userId: string;
}

// we use the persistor to have 1 user have a consisten color throughout the app
const InitialsAvatar = ({ userId, user }: InitialsAvatarProps) => {
  if (!user) return null;

  if (user.hasAvatar) {
    return <Image avatar src={user.avatar} />
  }
  return <InitialsAvatarComponent name={user.name} userId={userId} />;
}

interface IAvatarProps {
  userId: string;
}

const Avatar: React.FunctionComponent<IAvatarProps> = ({ userId }) => {
  const { data = {}, loading } = useQuery(GET_USER_INFO, {
    variables: { userId },
    fetchPolicy: "cache-first",
    skip: !userId
  });

  return loading ?
    <Loader active inline size="tiny" /> :
    <InitialsAvatar
      userId={userId}
      user={data?.user}
    />

};

export default Avatar;